module.exports = __webpack_public_path__ + "img/Arrow_Right.b5517916.svg";